import { render, staticRenderFns } from "./ActionPropertiesManager.vue?vue&type=template&id=bd4b7350&"
import script from "./ActionPropertiesManager.vue?vue&type=script&lang=ts&"
export * from "./ActionPropertiesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports